import { useEffect } from 'react';
import gilroyEot from './font/Gilroy-Regular.eot';
import gilroyWoff from './font/Gilroy-Regular.woff';
import gilroyWoff2 from './font/Gilroy-Regular.woff2';
import gilroyTtf from './font/Gilroy-Regular.ttf';
import gilroyMediumEot from './font/Gilroy-Medium.eot';
import gilroyMediumWoff from './font/Gilroy-Medium.woff';
import gilroyMediumWoff2 from './font/Gilroy-Medium.woff2';
import gilroyMediumOtf from './font/Gilroy-Medium.otf';
import gilroyBoldEot from './font/Gilroy-Bold.eot';
import gilroyBoldWoff from './font/Gilroy-Bold.woff';
import gilroyBoldWoff2 from './font/Gilroy-Bold.woff2';
import gilroyBoldTtf from './font/Gilroy-Bold.ttf';
import gilroyItalicEot from './font/Gilroy-RegularItalic.eot';
import gilroyItalicWoff from './font/Gilroy-RegularItalic.woff';
import gilroyItalicWoff2 from './font/Gilroy-RegularItalic.woff2';
import gilroyItalicTtf from './font/Gilroy-RegularItalic.ttf';
import gilroyBoldItalicEot from './font/Gilroy-BoldItalic.eot';
import gilroyBoldItalicWoff from './font/Gilroy-BoldItalic.woff';
import gilroyBoldItalicWoff2 from './font/Gilroy-BoldItalic.woff2';
import gilroyBoldItalicTtf from './font/Gilroy-BoldItalic.ttf';
export const GilroyFont = () => {
  useEffect(() => {
    if (document.querySelector('style[data-tombac-style="gilroy"]')) return;
    const styleElement = document.createElement('style');
    styleElement.setAttribute('data-tombac-style', 'gilroy');
    styleElement.innerHTML = `@font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-weight: 400;
      src: url(${gilroyEot});
      src: url(${gilroyEot}?#iefix) format('embedded-opentype'),
        url(${gilroyWoff2}) format("woff2"),
        url(${gilroyWoff}) format("woff"),
        url(${gilroyTtf}) format("truetype");
    }
    @font-face {
      font-family: 'Gilroy';
      font-style: italic;
      font-weight: 400;
      src: url(${gilroyItalicEot});
      src: url(${gilroyItalicEot}?#iefix) format('embedded-opentype'),
        url(${gilroyItalicWoff2}) format("woff2"),
        url(${gilroyItalicWoff}) format("woff"),        
        url(${gilroyItalicTtf}) format("truetype");
    }
    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-weight: 500;
      src: url(${gilroyMediumEot});
      src: url(${gilroyMediumEot}?#iefix) format('embedded-opentype'),
        url(${gilroyMediumWoff2}) format("woff2"),
        url(${gilroyMediumWoff}) format("woff"),        
        url(${gilroyMediumOtf}) format("opentype");
    }
    @font-face {
      font-family: 'Gilroy';
      font-style: normal;
      font-weight: 700;
      src: url(${gilroyBoldEot});
      src: url(${gilroyBoldEot}?#iefix) format('embedded-opentype'),
        url(${gilroyBoldWoff2}) format("woff2"),
        url(${gilroyBoldWoff}) format("woff"),
        url(${gilroyBoldTtf}) format("truetype");
    }
    @font-face {
      font-family: 'Gilroy';
      font-style: italic;
      font-weight: 700;
      src: url(${gilroyBoldItalicEot});
      src: url(${gilroyBoldItalicEot}?#iefix) format('embedded-opentype'),
        url(${gilroyBoldItalicWoff2}) format("woff2"),
        url(${gilroyBoldItalicWoff}) format("woff"),
        url(${gilroyBoldItalicTtf}) format("truetype");
    }`;
    document.head.appendChild(styleElement);
  }, []);
  return null;
};
//# sourceMappingURL=GilroyFont.js.map